import { useInternationalization } from '@progress/kendo-react-intl';
import { convertDateFormat, getName, formatBytes } from '../helpers/helperMethods';
import { DataModel } from '../interfaces/FileManagerModels';
import { SvgIcon } from '@progress/kendo-react-common';
import { fileIcon } from '@progress/kendo-svg-icons';
import {Box} from "@mui/material";

export const FileInformation = (props) => {
  console.log(props)
  return (
    props.data
      ? typeof props.data === 'number' ? MultipleSelectionRendering(props.data) : FileSelectionRendering(props.data)
      : NoDataRendering());
}

const NoDataRendering = () => {
  return (
    <div className="k-filemanager-preview" style={{ width: '100%', border: 0 }}>
      <div className="k-file-info">
        <span className="k-file-preview">
          <span className="k-file-icon k-icon k-icon k-i-none">
          </span>
        </span>
        <span className="k-file-name k-no-file-selected">No File Selected</span>
      </div>
    </div>
  )
}

const FileSelectionRendering = (item: DataModel) => {
  const intl = useInternationalization();
  const dateCreated: String = item.dateCreated ? item.dateCreated : null;
  const dateModified: String = item.dateModified ? item.dateModified : null;
  const { svgIcon }  = item.icon!;
  
  return (
    <div className="k-filemanager-preview" style={{ width: '100%', border: 0 }}>
      <div className="k-file-info">
        <span className="k-file-preview">
          {item.Thumbnail == null ?
              <SvgIcon icon={svgIcon} size='xlarge'/>
              :
              <Box
                  component="img"
                  sx={{
                    height: 233,
                    width: 350,
                    maxHeight: { xs: 233, md: 167 },
                    maxWidth: { xs: 350, md: 250 },
                  }}
                  alt=""
                  src={item.Thumbnail}
              />
          }
        </span>
        <span className="k-file-name k-single-file-selected">{item.path ? getName(item.path) : ''}</span>
        <dl className="k-file-meta">
          <dt className="k-file-meta-label">Type:  </dt>
          <dd className={"k-file-meta-value k-file-type"}> {item.icon ? item.icon.type : ''}</dd>
          <div style={{display: item.size > 0 ? 'inline' : 'none'}} className="k-line-break"></div>
          <dt style={{display: item.size > 0 ? 'inline' : 'none'}} className="k-file-meta-label">Size:  </dt>
          <dd style={{display: item.size > 0 ? 'inline' : 'none'}} className="k-file-meta-value k-file-size"> {item.size ? formatBytes(item.size) : ''}</dd>
          <dd className="k-line-break"></dd>
          <dt className="k-file-meta-label">Date Created:  </dt>
          <dd className="k-file-meta-value k-file-created"> {dateCreated ? dateCreated : ''}</dd>
          <dd className="k-line-break"></dd>
          <dt className="k-file-meta-label">Date Modified:  </dt>
          <dd className="k-file-meta-value k-file-modified"> {dateModified ? dateModified : ''}</dd>
          <dd className="k-line-break"></dd>
        </dl>
      </div>
    </div>
  );
}

const MultipleSelectionRendering = (length: number) => {
  return (
    <div className="k-filemanager-preview" style={{ width: '100%', border: 0 }}>
      <div className="k-file-info">
        <span className="k-file-preview" style={{ width: '100%', border: 0 }}>
          <SvgIcon icon={fileIcon} size='xlarge'/>
        </span>
        <span className="k-file-name k-multiple-files-selected">{length} items</span>
      </div>
    </div>
  );
}
